import { Menu } from '@tamagui/lucide-icons';
import { Header as BaseHeader } from '@unistocks/components/navigation/header';
import { HeaderButton } from '@unistocks/components/page/header/header-button/header-button';
import { NotificationIcon } from '@unistocks/components/page/header/notification-icon/notification-icon';
import { SignalRStatus } from '@unistocks/components/page/header/signalr-status/signalr-status';
import { Drawer } from '@unistocks/features/navigation/drawer';
import { ProfileMenu } from '@unistocks/features/navigation/profile-menu';
import { useDevToolsEnabled } from '@unistocks/shared/hooks/use-feature';
import { useToggle } from '@unistocks/shared/hooks/use-toggle';
import { isWeb, useMedia } from 'tamagui';

export const Header: React.FC = () => {
  const media = useMedia();
  const [open, toggleOpen, setOpen] = useToggle(false);
  const withSidebar = isWeb && media.md;
  const isDevToolsEnabled = useDevToolsEnabled();

  return (
    <>
      <BaseHeader
        withSidebar={withSidebar}
        /* renderRoutes={
          media.md
            ? () => <RoutesNavBar flexDirection="row" justifyContent={'flex-start'} />
            : undefined
        } */
        renderRight={() => (
          <>
            {isDevToolsEnabled ? <SignalRStatus /> : null}
            <NotificationIcon size={'$2'} />
            <ProfileMenu display="none" $md={{ display: 'flex' }} />
            <HeaderButton $md={{ display: 'none' }} Icon={Menu} onPress={toggleOpen} />
          </>
        )}
      />
      <Drawer open={open} onOpenChange={setOpen} />
    </>
  );
};

Header.displayName = 'Header';
